export class FileUtils {
  static isFileExt(file: File, ext: string) {
    return FileUtils.isFileExts(file, [ext]);
  }

  static isExt(fileName: string, ext: string) {
    return FileUtils.isExts(fileName, [ext]);
  }

  static isFileExts(file: File, exts: string[]) {
    return FileUtils.isExts(file.name, exts);
  }

  static isExts(fileName: string, exts: string[]) {
    if (exts.includes('*')) {
      return true;
    }

    const aux = exts.join('|\\');
    return new RegExp(`(\\${aux})$`, 'i').test(fileName);
  }

  static writeFileFromText(text: string, fileName: string) {
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    return new File([blob], fileName);
  }
}
